import { useState } from "react";

export default function Enquiry() {
  const products = [
    "Ponni Boiled Rice",
    "Ponni Raw Rice",
    "Basmati Rice",
    "Dry Chilli",
    "Black Pepper",
    "Cardamom",
    "Turmeric",
    "Cinnamon",
    "Coriander",
    "Cumin",
    "Jeera",
    "Toor Dal",
    "Urad Dal",
    "Channa Dal",
    "Moong Dal",
    "Maize",
    "Betel Nut",
  ];

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    product: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!form.name || !form.email || !form.product || !form.message) {
      alert("Please fill all required fields!");
      return;
    }

    const subject = "New Enquiry - Venkata Sai Traders";

    const body = `
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Product: ${form.product}

Message:
${form.message}
    `;

    // Open email client
    window.location.href = `mailto:info@venkatasaitraders.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Reset form
    setForm({
      name: "",
      email: "",
      phone: "",
      product: "",
      message: "",
    });

    alert("Opening your email app to send enquiry!");
  };

  return (
    <section id="contact" className="py-16 bg-gray-100 reveal">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center px-6">

        {/* LEFT SIDE */}
        <div className="space-y-6">

          {/* IMAGE */}
          <div className="relative h-[300px] rounded-xl overflow-hidden shadow-lg">
            <img
              src="https://images.unsplash.com/photo-1495107334309-fcf20504a5ab"
              alt="Agro Export"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center text-white text-center p-6">
              <div>
                <h2 className="text-2xl font-bold mb-2">
                  Global Trade Inquiry
                </h2>
                <p className="text-sm">
                  Connect with us for premium agro exports worldwide
                </p>
              </div>
            </div>
          </div>

          {/* ADDRESS */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-bold text-lg mb-2">📍 Office Address</h3>
            <p className="text-sm text-gray-600">
              No: 1302, 3rd Floor, Golden Colony,<br />
              Anna Nagar West Extn, Padi,<br />
              Chennai - 600050
            </p>

            <h3 className="font-bold text-lg mt-4 mb-2">🏢 Godown</h3>
            <p className="text-sm text-gray-600">
              No: 6A, Kattabomman 3rd Street,<br />
              Naravarikuppam, Redhills,<br />
              Chennai - 600052
            </p>

            <h3 className="font-bold text-lg mt-4 mb-2">🏢 Head Office</h3>
            <p className="text-sm text-gray-600">
              No: 9-874, Shankarpalli Market Road,<br />
              Hyderabad, Rangareddy District,<br />
              Telangana - 501203
            </p>
          </div>

        </div>

        {/* RIGHT FORM */}
        <div className="bg-white p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-bold mb-6">
            Send Your Enquiry
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">

            <input
              type="text"
              name="name"
              value={form.name}
              placeholder="Your Name"
              onChange={handleChange}
              required
              className="w-full border p-3 rounded focus:ring-2 focus:ring-green-600"
            />

            <input
              type="email"
              name="email"
              value={form.email}
              placeholder="Your Email"
              onChange={handleChange}
              required
              className="w-full border p-3 rounded focus:ring-2 focus:ring-green-600"
            />

            <input
              type="tel"
              name="phone"
              value={form.phone}
              placeholder="Phone Number"
              onChange={handleChange}
              className="w-full border p-3 rounded focus:ring-2 focus:ring-green-600"
            />

            <select
              name="product"
              value={form.product}
              onChange={handleChange}
              required
              className="w-full border p-3 rounded focus:ring-2 focus:ring-green-600"
            >
              <option value="">Select Product</option>
              {products.map((product, index) => (
                <option key={index} value={product}>
                  {product}
                </option>
              ))}
            </select>

            <textarea
              rows="4"
              name="message"
              value={form.message}
              placeholder="Your Message"
              onChange={handleChange}
              required
              className="w-full border p-3 rounded focus:ring-2 focus:ring-green-600"
            />

            <button
              type="submit"
              className="w-full bg-green-700 text-white py-3 rounded hover:bg-green-800 transition"
            >
              Send Enquiry
            </button>

          </form>

          {/* WHATSAPP BUTTON (Optional) */}
          <a
            href="https://wa.me/919XXXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center mt-4 bg-green-600 text-white py-3 rounded hover:bg-green-700"
          >
            Chat on WhatsApp
          </a>

        </div>

      </div>
    </section>
  );
}